/* eslint-disable */

import 'bootstrap';
// import 'slick-carousel';

// import 'bootstrap/js/src/util';
// import 'bootstrap/js/src/collapse';
// import 'bootstrap/js/src/dropdown';
// import 'bootstrap/js/src/modal';

import bob      from './base/bob';
// import anchors  from './base/anchors';
import collapse  from './base/collapse';
import tables   from './base/tables';
import navigationDrawer from './base/navigation-drawer';
import popuplink from './base/popuplink';
import formModal from './base/form-modal';
import navigation from './base/navigation';

/* eslint-enable */

bob.init();
// anchors.init();
collapse.init();
tables.init();
navigationDrawer.init();
popuplink.init();
formModal.init();
navigation.init();
